import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { getCrmSettings } from '../ApiServices';

const CrmSettingsContext = createContext();

export const CrmSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCrmSettings = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getCrmSettings();
      setSettings(data.data);
      return data.data;
    } catch (err) {
      console.error('Failed to fetch CRM settings:', err);
      setError(err.message || 'Failed to fetch settings');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshSettings = async () => {
    return await fetchCrmSettings();
  };

  useEffect(() => {
    fetchCrmSettings();
  }, [fetchCrmSettings]);

  const getSettingByKey = (key) => {
    if (!settings || !Array.isArray(settings)) return null;
    const setting = settings.find(item => item.key === key);
    return setting ? setting.value : null;
  };

  const value = {
    settings, 
    loading,
    error,
    refreshSettings,
    getSettingByKey, 
    updateSettings: (newSettings) => setSettings(prev => ({ ...prev, ...newSettings }))
  };

  return (
    <CrmSettingsContext.Provider value={value}>
      {children}
    </CrmSettingsContext.Provider>
  );
};

export const useCrmSettings = () => {
  const context = useContext(CrmSettingsContext);
  if (context === undefined) {
    throw new Error('useCrmSettings must be used within a CrmSettingsProvider');
  }
  return context;
};